import type { Identity } from '@/platform';
import {
  type DriverMode,
  type DriverStatus,
  DriverStatusKind,
  type GameDriver,
} from '@/shared/lib/driver';
import type { SessionSlice as SessionSliceCreator } from '@/shared/lib/zustand-types';

/**
 * `Identity` lives at the platform tier (every identity provider produces
 * one). Re-exported here so existing feature imports of
 * `@/features/session` keep compiling.
 */
export type { Identity };

export type SessionSlice = {
  identity: Identity | null;
  mode: DriverMode | null;
  driver: GameDriver | null;
  driverStatus: DriverStatus;

  setIdentity: (identity: Identity) => void;
  clearIdentity: () => void;
  setDriver: (driver: GameDriver | null) => void;
  setDriverStatus: (status: DriverStatus) => void;
  setMode: (mode: DriverMode | null) => void;
};

export const createSessionSlice: SessionSliceCreator<SessionSlice> = (set) => ({
  identity: null,
  mode: null,
  driver: null,
  driverStatus: { kind: DriverStatusKind.Idle },

  setIdentity: (identity) =>
    set((s) => {
      s.identity = identity;
    }),
  clearIdentity: () =>
    set((s) => {
      s.identity = null;
    }),
  setDriver: (driver) =>
    set((s) => {
      s.driver = driver;
    }),
  setDriverStatus: (status) =>
    set((s) => {
      s.driverStatus = status;
    }),
  setMode: (mode) =>
    set((s) => {
      s.mode = mode;
    }),
});
